import { forwardRef } from 'react'
import ReactMarkdown from 'react-markdown'
import styled from 'styled-components'

import { font, tablet } from '@scouts/ui'

import LinkRenderer from '../LinkRenderer'

const AgreementBody = styled.div`
    font-family: sans-serif;

    h1 {
        font-size: ${font.large};
        margin: 24px 0;

        ${tablet`
            font-size: ${font.larger};
        `}
    }

    h2 {
        font-size: ${font.large};
        margin: 24px 0;
    }

    h3 {
        font-weight: bold;
        text-transform: uppercase;
        margin: 24px 0;
    }

    strong {
        font-weight: bold;
    }

    ul,
    ol {
        margin: 18px 0;
        padding-left: 36px;
    }

    p {
        line-height: 1.5;
        white-space: pre-line;
        margin: 0;
    }

    li {
        line-height: 1.5;
        margin: 0;
        margin-top: 12px;

        &:not(:last-child) {
            margin-bottom: 6px;
        }

        p {
            margin: 0;
            padding: 0;
        }
    }

    p:not(:last-child) {
        margin-bottom: 6px;
    }

    hr {
        margin: 24px 0;
        border: 0;
    }

    hr + hr {
        margin-bottom: 48px;
    }
`

const serviceAgreementRenderers = { a: LinkRenderer }

const ServiceAgreementBody = forwardRef<HTMLDivElement, { source: string }>(({ source }, ref) => (
    <div className="sensitive">
        <AgreementBody ref={ref}>
            {/* @TODO: */}
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            <ReactMarkdown components={serviceAgreementRenderers as any}>{source}</ReactMarkdown>
        </AgreementBody>
    </div>
))

export default ServiceAgreementBody
